<script setup lang="ts">

import type {DiscountCodeResponse} from "../../../responses/DiscountCodeResponse.ts";
import {computed, type ComputedRef, ref, type Ref} from "vue";
import Button from "../../../backend/ui/Button.vue";
import {SaveIcon} from 'lucide-vue-next'
import Input from "../../../backend/ui/Input.vue";
import {label} from "../../mixins/translations.ts";
import {toast} from "vue-sonner";
import {useCartStore} from "../../stores/cart.ts";
import Errors from "../Errors.vue";
import Error from "../Error.vue";

interface Props {
    discount_models: DiscountCodeResponse[]|null
}

defineProps<Props>()


const cartStore = useCartStore();

const discountCode: Ref<string> = ref('');
const errorMessage: Ref<string> = ref('');
const showInput : Ref<boolean> = ref(false);

const discounts = computed(() => {
    return cartStore.getDiscounts();
});


const submitCode = async () => {
    await cartStore.validateDiscountCode({ discountCode: discountCode.value}).then((response) => {
        if(response.data.valid) {
            toast.success(response.data.message);
            showInput.value = false;
            discountCode.value = '';
        } else {
            errorMessage.value = response.data.message;
            toast.error(response.data.message);
        }
    }).catch((response) => {
        errorMessage.value = response.data.message;
    })
}

const removeCode = async (code) => {
    await cartStore.deleteDiscountCode({ discountCode: code}).then((response) => {
    }).catch((response) => {
        errorMessage.value = response.data.message;
    })
}

</script>

<template>
    <div>
        <div class="flex flex-col" v-for="discount of discounts">
            <div class="flex flex-row justify-between align-middle">
                <div v-text="discount.code"></div>
                <div class="cursor-pointer" @click="removeCode(discount.code)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-link underline" @click.prevent="showInput = true" v-if="!showInput">
            {{ label('site.cart.discount_code.apply') }}
        </button>

        <div class="flex flex-col" v-if="showInput">
            <div class="flex gap-2">
                <input type="text" id="discount_code" v-model="discountCode" :placeholder="label('site.cart.discount_code')" required
                       class="bg-white border border-secondary-100 focus:shadow-md focus:shadow-gray-200 text-gray-900 text-sm rounded-sm focus:ring-secondary-200 focus:border-secondary-100 block w-full p-3"
                       @keydown.enter.prevent="submitCode"
                />
                <button type="button" @click.prevent="submitCode">
                    <SaveIcon class="" />
                </button>
            </div>
            <Error :error="errorMessage" class="pl-2 pt-1"/>
        </div>
    </div>

</template>
